export default `query ($token: String!,$courseId:String!,$limit: Int, $offset: Int, $isPhysicalDeliveryEnabled: Int, $bundlingId : Int){
  withAuth(token: $token) {
    user {
      id
      region
      language
      student {
        id
        inVisibleCouponCount(courseId: $courseId,isPhysicalDeliveryEnabled:$isPhysicalDeliveryEnabled)
        coupons(limit:$limit, offset:$offset, courseIds:[$courseId],isPhysicalDeliveryEnabled:$isPhysicalDeliveryEnabled,bundlingId:$bundlingId) {
          id
          code
          amount
          discountType
          maxAmount
          couponType
          name
          endDateTime
        }
      }
      redeems(courseIds:[$courseId], state: CLAIMED) {
        id
        coupon {
          id
          code
          amount
          discountType
          maxAmount
          couponType
          name
        }
      }
    }
  }
}
mapper<safejs-
const redeems = data.withAuth.user.redeems &&  data.withAuth.user.redeems.length ? data.withAuth.user.redeems[0] : {coupon: null, id: null};
const inVisibleCouponCount = data.withAuth.user.student.inVisibleCouponCount;
const totalCount = data["student_"+data.withAuth.user.student.id+"_coupons_total"];
data = couponApplyAndRemove(data.withAuth.user.student.coupons, redeems.coupon, redeems.id, totalCount,data.withAuth.user.region, 0,data.withAuth.user.language);
data.inVisibleCouponCount = inVisibleCouponCount;
data.totalCount = totalCount;
-js>`;
